import doc                    from '@widesk-core/decorators/doc';
import AbstractUserGroupModel from './AbstractUserGroupModel';
import model                  from '@widesk-core/decorators/model';

@doc.urnResource('user_group')
@model.cacheDuration()
export default class UserGroupModel extends AbstractUserGroupModel {}
